import {
  FormControlLabel as MuiFormControlLabel,
  formControlLabelClasses,
  FormControlLabelProps,
  styled,
} from '@mui/material'

export const FormControlLabel = styled(
  MuiFormControlLabel,
)<FormControlLabelProps>(({ theme }) => ({
  margin: 0,

  [`& .${formControlLabelClasses.label}`]: {
    marginLeft: theme.spacing(1),
    fontSize: theme.typography.caption2.fontSize,
    fontWeight: 600,
    lineHeight: theme.typography.caption3.lineHeight,

    '&.Mui-disabled': {
      color: theme.palette.text.primary,
    },
  },
}))
